import { Base } from "./Base";

export class PostItem extends Base {
  _id?: string;
  communities!: [{ label: string; value: string }];
  communityId: string;
  contentId!: string;
  // content!: ContentItem;
  tags!: string[];
  post!: string;
  owner!: string;
  status!: string;
  created!: string;
  community?: any;
  user?: any;
  sessionContentItem?: any;
  eventContentItem?: any;
  content?: ContentItem;
  postSettings!: PostSettings;
  constructor(args: Partial<PostItem>) {
    super(args);
  }
}

export class ContentItem extends Base {
  _id?: string;
  title!: string;
  type!: string;
  created!: string;
  modified: string;
  modifiedBy: any;
  publishAmount!: number;
  createdBy!: any;
  uploadedBy!: any;
  showInSearch!: boolean;
  community!: string;
  user?: any;
  thumbnail?: any;
  description!: string;
  tags!: string[];
  whoCanSee?: number;
  createdOn?: any;
  fileType? :string;
  related: string[];
  division?: string;
  status?: string;
  file?: string;
  // media! : MediaItem[];
  //CONSIDER THIS OPTION? (WRITTEN BY ZOHAR)
  media!: [
    | MediaItem
    | MediaFile
    | SefariaLink
    | HartmanLink
    | ExternalLink
    | SessionRecording
    | any
  ];
  constructor(args: Partial<ContentItem>) {
    super(args);
  }
}

export class MediaItem extends Base {
  type?: string;
  constructor(args: Partial<MediaItem>) {
    super(args);
  }
}

export class MediaFile extends MediaItem {
  file?: any;
  link?: string;
  constructor(args: Partial<MediaFile>) {
    super(args);
  }
}

export class SefariaLink extends MediaItem {
  content?: any;
  link?: any;
  constructor(args: Partial<SefariaLink>) {
    super(args);
  }
}

export class HartmanLink extends MediaItem {
  link?: any;
  constructor(args: Partial<HartmanLink>) {
    super(args);
  }
}

export class ExternalLink extends MediaItem {
  link?: any;
  constructor(args: Partial<ExternalLink>) {
    super(args);
  }
}

export class SessionRecording extends MediaItem {
  link?: any;
  constructor(args: Partial<SessionRecording>) {
    super(args);
  }
}

export interface PostSettings {
  showInSearch: boolean;
  onlyToCommunity: boolean;
  pinToTop: boolean;
  alertUsers: boolean;
}
